import React, { memo } from 'react';
import { AppNode, NodeType, NodeStatus } from '@/types';
import { AlertCircle, Loader2, Grid3x3 } from 'lucide-react';
import { PanoramaViewer } from '../../../../panorama';

export const PanoramaContent: React.FC<{
  data: AppNode;
  isWorking: boolean;
  hasError: boolean;
  onNodeUpdate: (id: string, data: Partial<AppNode['data']>, size?: { width?: number; height?: number }, title?: string) => void;
}> = memo(({ data, isWorking, hasError, onNodeUpdate }) => (
  <div className="w-full h-full flex flex-col justify-center items-center relative overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-teal-500/10 to-cyan-900/10 z-0" />
    {isWorking ? (
      <div className="flex flex-col items-center gap-3 z-10 select-none">
        <Loader2 size={32} className="text-teal-400 animate-spin" />
        <span className="text-xs text-white/60 font-medium">生成全景图中...</span>
      </div>
    ) : data.data.panoramaOutputUrl ? (
      <>
        {data.data.isPanoramaPreviewOpen ? (
          <PanoramaViewer
            imageUrl={data.data.panoramaOutputUrl}
            onClose={() => onNodeUpdate(data.id, { isPanoramaPreviewOpen: false })}
            inline
          />
        ) : (
          <>
            <img
              src={data.data.panoramaOutputUrl}
              className="w-full h-full object-cover"
              draggable={false}
            />
            <button
              onClick={(e) => { e.stopPropagation(); onNodeUpdate(data.id, { isPanoramaPreviewOpen: true }); }}
              className="absolute top-3 left-3 z-10 flex items-center justify-center w-10 h-10 rounded-lg bg-black/50 backdrop-blur-sm border border-white/15 text-white text-xs font-bold hover:bg-black/70 transition-all"
              title="进入全景模式"
            >
              720°
            </button>
          </>
        )}
      </>
    ) : (
      <div className="flex flex-col items-center justify-center z-10 select-none">
        <Grid3x3 size={48} className={`transition-opacity duration-300 ${isWorking ? 'text-teal-400/30' : 'text-white/[0.08]'}`} />
      </div>
    )}
    {hasError && (
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md flex flex-col items-center justify-center p-6 text-center z-20">
        <AlertCircle className="text-red-500 mb-2" size={20} />
        <span className="text-xs text-red-200">{data.data.error}</span>
      </div>
    )}
  </div>
));
